const mathOps = ['+', '-', '*', '/', '^']

/**
 * Operations that start with either of: +, -, *, /, ^
 */
export const isRelativeMathOps = (value: string) => {
  return mathOps.includes(value[0])
}
